module.exports = __webpack_public_path__ + "static/img/logo_4.5ec93d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo_4.png
// module id = q3NN
// module chunks = 1